// Packages
import { createApp, defineAsyncComponent } from 'vue';
import { initDropdowns } from 'flowbite';

// Vue components
import PeopleSearch from '@vue-components/PeopleSearch.vue';

export default function init(): void {
  // Create Vue instance for people search
  const vueInstance = createApp({
    name: 'PeopleIndex',
    compilerOptions: {
      delimiters: ['${', '}'],
    },
    components: {
      PeopleSearch,
      PersonCard: defineAsyncComponent(() => import('@vue-components/cards/PersonCard.vue')),
    },
    mounted() {
        initDropdowns();
      },
  });

  // Mount the app
  vueInstance.mount('#people-index');
}
